module.exports = __webpack_public_path__ + "img/ticket.1beea04b.svg";